// extracted by mini-css-extract-plugin
module.exports = {"group":"_38fea9f","leftAlign":"_9cd7827","inline":"_2c2ace6"};